import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Button,
  CircularProgress,
  Grid,
  Typography,
  Paper,
  List,
  Tabs,
  Tab,
  IconButton,
  Collapse,
  Modal,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { fetchOperatorDetails, fetchRechargePlans, payBill } from "./apiServices";

const MobilePrepaidRecharge = () => {
  const [mobileNumber, setMobileNumber] = useState("");
  const [operatorDetails, setOperatorDetails] = useState(null);
  const [rechargePlans, setRechargePlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [expandedPlan, setExpandedPlan] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [paymentResponse, setPaymentResponse] = useState(null); // State to store payment response

  // Validate mobile number
  const validateMobileNumber = (number) => {
    return /^\d{10}$/.test(number);
  };

  // Handle mobile number input change
  const handleMobileNumberChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && value.length <= 10) {
      setMobileNumber(value);
    }
  };

  // Fetch operator details automatically when mobile number is complete
  useEffect(() => {
    if (validateMobileNumber(mobileNumber)) {
      fetchOperatorDetailsAutomatically();
    }
  }, [mobileNumber]);

  // Fetch operator details automatically
  const fetchOperatorDetailsAutomatically = async () => {
    setLoading(true);
    setError("");
    setOperatorDetails(null);

    try {
      const operatorResponse = await fetchOperatorDetails(mobileNumber);
      console.log("Operator Response:", operatorResponse);

  
        setOperatorDetails({
          operatorName: operatorResponse.Operator,
          circle: operatorResponse.comcircle,
        });

        console.log("Tanmayyyyyyyyyy",operatorDetails.operatorName);
        console.log("Jalebiiiiiiiiiii",operatorDetails.circle);
        console.log("Samooseeeeeeeeeeee",!operatorDetails)
        if(operatorDetails!==null){
        toast.success("Operator details fetched successfully.");
      } else {
        setError("Failed to fetch operator details.");
      }
    } catch (err) {
      setError("An error occurred. Please try again.");
      toast.error("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Fetch recharge plans
  const handleProceed = async () => {
    if (!validateMobileNumber(mobileNumber)) {
      toast.error("Please enter a valid 10-digit mobile number.");
      return;
    }

    if (!operatorDetails) {
      toast.error("Operator details not available.");
      return;
    }

    setLoading(true);
    setError("");
    setRechargePlans([]);

    try {
      const plansResponse = await fetchRechargePlans(
        mobileNumber,
        operatorDetails.operatorName,
        operatorDetails.circle
      );
      console.log("Plans Response In Mobile Recharge ", plansResponse);

      if (plansResponse?.body?.response?.plans) {
        // Group plans by planCategory
        const groupedPlans = plansResponse.body.response.plans.reduce((acc, plan) => {
          console.log("In Filter   ", plan);
          const category = plan.planCategory;
          if (!acc[category]) {
            acc[category] = [];
          }
          acc[category].push({
            price: plan.planAmount,
            validity: plan.planValidity,
            description: plan.planDescription,
            subProductCode: plan.subProductCode,
          });
          return acc;
        }, {});

        setRechargePlans(groupedPlans);

        // Set the first category as the default selected category
        const firstCategory = Object.keys(groupedPlans)[0];
        setSelectedCategory(firstCategory);
      } else {
        setError("Failed to fetch recharge plans.");
      }
    } catch (err) {
      setError("An error occurred. Please try again.");
      toast.error("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Handle category selection
  const handleCategoryClick = (category) => {
    setSelectedCategory(category === selectedCategory ? null : category);
  };

  // Handle plan expansion
  const handlePlanExpand = (index) => {
    setExpandedPlan(expandedPlan === index ? null : index);
  };

  // Open modal when a plan is selected
  const handleBuyPlanClick = (plan) => {
    setSelectedPlan(plan);
    setOpenModal(true);
  };

  // Close modal
  const handleCloseModal = () => {
    setOpenModal(false);
    setPaymentResponse(null); // Reset payment response when modal is closed
  };

  // Handle payment
  const handlePayment = async () => {
    if (!selectedPlan) return;

    setLoading(true);
    try {
      console.log("Kamrannnn Aslam Khannnn ", selectedPlan);
      console.log("Kamrannnn Khannnn ", selectedPlan.subProductCode);
      const paymentResponse = await payBill(
        selectedPlan.subProductCode, // Replace with actual billerId
        { param1: mobileNumber }, // Replace with actual inputParameters
        selectedPlan.price, // Transaction amount
        "AGT", // Replace with actual initChannel
        "NEFT", // Replace with actual paymentModes
        "123", // Replace with actual enquiryReferenceId
        false, // Replace with actual validateBiller
        "Mobile Recharge" // Service name
      );

      // Store the payment response
      setPaymentResponse(paymentResponse);

      if (paymentResponse?.body?.statusCodeValue === 200) {
        toast.success("Payment successful!");
      } else {
        toast.error("Payment failed. Please try again.");
      }
    } catch (err) {
      toast.error("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Selected Plan Card Component
  const SelectedPlanCard = ({ plan, onPayment }) => {
    if (!plan) return null;

    return (
      <Paper elevation={3} style={{ marginBottom: "1rem", padding: "1rem" }}>
        <Typography variant="h6" style={{ fontWeight: "bold" }}>
          ₹{plan.price}
        </Typography>
        <Typography>{plan.validity}</Typography>
        <Typography>
          <strong>Description:</strong> {plan.description}
        </Typography>
        <Box mt={2} display="flex" justifyContent="flex-end">
          <Button
            variant="contained"
            color="primary"
            onClick={onPayment}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : "Proceed to Payment"}
          </Button>
        </Box>
      </Paper>
    );
  };

  return (
    <Box style={{ padding: "2rem" }}>
      <ToastContainer />
      <Grid container spacing={2}>
        {/* Mobile Number Input Field */}
        <Grid item md={4} xs={12}>
          <TextField
            fullWidth
            label="Enter Mobile Number"
            value={mobileNumber}
            onChange={handleMobileNumberChange}
            inputProps={{ maxLength: 10 }}
            placeholder="10-digit mobile number"
            error={!!error}
            helperText={error}
          />
        </Grid>

        {/* Operator Input Field */}
        {operatorDetails && (
          <Grid item md={4} xs={12}>
            <TextField
              fullWidth
              label="Operator"
              value={operatorDetails.operatorName}
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
        )}

        {/* Circle Input Field */}
        {operatorDetails && (
          <Grid item md={4} xs={12}>
            <TextField
              fullWidth
              label="Circle"
              value={operatorDetails.circle}
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
        )}
      </Grid>

      {/* Proceed Button */}
      <Box mt={3} display="flex" justifyContent="flex-end">
        <Button
          variant="contained"
          onClick={handleProceed}
          disabled={loading || !validateMobileNumber(mobileNumber)}
          style={{
            backgroundColor: "#027BFE",
            color: "white",
            padding: "10px 30px",
            fontSize: "16px",
            borderRadius: "8px",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "#0266CC",
            },
          }}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : "Proceed"}
        </Button>
      </Box>

      {/* Display recharge plans grouped by category */}
      {Object.keys(rechargePlans).length > 0 && (
        <Box mt={4}>
          <Typography variant="h6" gutterBottom>
            Recharge Plans
          </Typography>

          {/* Category Tabs */}
          <Tabs
            value={selectedCategory || false}
            onChange={(e, newValue) => setSelectedCategory(newValue)}
            variant="scrollable"
            scrollButtons="auto"
          >
            {Object.keys(rechargePlans).map((category) => (
              <Tab
                key={category}
                label={category}
                value={category}
                onClick={() => handleCategoryClick(category)}
              />
            ))}
          </Tabs>

          {/* Plans for Selected Category */}
          {selectedCategory && (
            <Box mt={2}>
              <List>
                {rechargePlans[selectedCategory].map((plan, index) => (
                  <React.Fragment key={index}>
                    <Paper elevation={3} style={{ marginBottom: "1rem", padding: "1rem" }}>
                      <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Box>
                          <Typography variant="h6" style={{ fontWeight: "bold" }}>
                            ₹{plan.price}
                          </Typography>
                          <Typography>{plan.validity}</Typography>
                        </Box>
                        <Box>
                          <IconButton onClick={() => handlePlanExpand(index)}>
                            <ExpandMoreIcon
                              style={{
                                transform: expandedPlan === index ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "transform 0.3s",
                              }}
                            />
                          </IconButton>
                        </Box>
                      </Box>

                      {/* Expandable Description */}
                      <Collapse in={expandedPlan === index}>
                        <Box mt={2}>
                          <Typography>
                            <strong>Description:</strong> {plan.description}
                          </Typography>
                          <Box mt={2} display="flex" justifyContent="flex-end">
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={() => handleBuyPlanClick(plan)}
                            >
                              Buy Plan
                            </Button>
                          </Box>
                        </Box>
                      </Collapse>
                    </Paper>
                  </React.Fragment>
                ))}
              </List>
            </Box>
          )}
        </Box>
      )}

      {/* Modal for Selected Plan */}
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="selected-plan-modal"
        aria-describedby="selected-plan-details"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" id="selected-plan-modal" gutterBottom>
            Selected Plan Details
          </Typography>
          {paymentResponse ? (
            <Box>
              <Typography variant="body1">
                <strong>Status:</strong> {paymentResponse.body?.response?.status||paymentResponse.body?.message||"Payment Failed"}
              </Typography>
              <Typography variant="body1">
                <strong>Message:</strong> {paymentResponse.body.message}
              </Typography>
              <Box mt={2} display="flex" justifyContent="flex-end">
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={handleCloseModal}
                >
                  Close
                </Button>
              </Box>
            </Box>
          ) : (
            <SelectedPlanCard plan={selectedPlan} onPayment={handlePayment} />
          )}
        </Box>
      </Modal>
    </Box>
  );
};

export default MobilePrepaidRecharge;